// extracted by mini-css-extract-plugin
module.exports = {"dateDivWrapper":"DateHeader_dateDivWrapper__3Y5RT","horizontalDiv":"DateHeader_horizontalDiv__OkU71","dateDiv":"DateHeader_dateDiv__CoRH0"};